const React = require('react');
const SharedModels = require('../../../shared/sharedModels');
const SharedConstants = require('../../../shared/sharedConstants');
const connect = require('react-redux/dist/react-redux.min.js').connect;
const ReduxStore = require('./redux/reduxStore.jsx.js');
const AjaxFunctions = require('./ajaxFunctions.js');
const Utils = require('./utils.js');
const CardComments = require('./components/cardComments.jsx').CardComments;
const ToastAlert = require('./components/toastAlert');

import CardFunctions from './components/cardFunctions';
import MPubCard, { MPubCardSimple, MPubCardSkeleton } from './components/mPubCard';
import { ApprovalControl } from './conjectureReview.jsx';
import { Button } from '@material-ui/core';

 export class CardMainContainer extends React.Component{
   constructor(props) {
      super(props);
      //TODO: skipLoading is a hack to get around the fact that there's a hard dependency on idCard in the address window.
      //TODO: It would be much better to make this a more pure class
      this.state = { isLoading: !props.skipLoading };
   }

   componentDidMount() {
      let idFromUrl = Utils.getParameterByName('idCard', window.location.href);
      if (idFromUrl) {
         this.updateCardData(idFromUrl)
            .then(() => this.setState({ isLoading: false }))
            .catch(err => ToastAlert.error(err));
      }
   }

   async createComment(text){
      await AjaxFunctions.createCardComment(SharedConstants.CardType.Reasoning, this.props.curCard.id, null, text, this.props.currentPortfolio);
      await this.updateCardData(this.props.curCard.id);
   }

   deleteCard(){
      AjaxFunctions.deleteConjecture(this.props.curCard.id).then(() => {
         window.location='/listView';
      });
   }

   async deleteComment(idCardComment){
      await AjaxFunctions.deleteCardComment(idCardComment);
      await this.updateCardData(this.props.curCard.id);
   }

   async updateCardData(idCard){
      let data = await AjaxFunctions.getGreySpaceCardByID(idCard);
      ReduxStore.store.dispatch(ReduxStore.GreySpaceCardFunctions.setCurrentCard(new SharedModels.GreySpaceCard(data)));
   }

   async createUpvote(){
      await AjaxFunctions.createUpvote(this.props.curCard.id, this.props.curCard.cardType);
      await this.updateCardData(this.props.curCard.id);
   }

   render() {
      const { curCard, idCurUser } = this.props;
      const { isLoading } = this.state;

      if (isLoading) return <MPubCardSkeleton />;
      return (
         <div className='greySpaceCard'>
            <div className='conjecture-pubs'>
               <MPubCard disableLink card={curCard} />
               <div className='evidence-pubs'>
                  <MPubCardSimple card={curCard.evidenceCard1} />
                  <MPubCardSimple card={curCard.evidenceCard2} />
               </div>
            </div>
            {!curCard.isApproved &&
               <ApprovalControl
                  idCard={curCard.id}
                  cardType={SharedConstants.CardType.Reasoning}
                  closeFunction={this.props.closeFunction}
               />
            }
            {window.globals.idUser &&
               <div className='card-modal-actions'>
                  <div className='published'>
                        <Button
                           className='upvote-btn'
                           onClick={() => this.createUpvote()}
                           style={{ textTransform: 'none' }}
                           startIcon={<span>{curCard.upvoteCount || 0}</span>}
                           disabled={curCard.idUpvoteForCurrentUser > 0 || curCard.idUser == window.globals.idUser}
                           color='primary'
                           variant='contained'
                           size='medium'
                        >
                           <div>Good Thinking!</div>
                        </Button>
                        {idCurUser && <CardFunctions card={curCard} />}
                  </div>
                  {(window.globals.isAdmin) && (
                     <div className='under-review'>
                        <Button
                           onClick={() => this.deleteCard()}
                           style={{ textTransform: 'none' }}
                           color='secondary'
                           variant='contained'
                           size='medium'
                        >
                           <div>Delete</div>
                        </Button>
                     </div>
                  )}
                  {this.props.showComments &&
                     <CardComments
                        comments={this.props.curCard.comments}
                        currentPortfolio={this.props.currentPortfolio}
                        createCommentFunction={text => this.createComment(text)}
                        deleteCommentFunction={idCardComment => this.deleteComment(idCardComment)}
                     />
                  }
               </div>
            }
         </div>
      );
   }
}

const mapCardMainContainerStateToProps = (state) => {
   return {
      isEditing: state.EditorReducer.isEditing,
      curCard: state.GreySpaceCardReducer.curCard,
      idCurUser: state.UserReducer.curUser.id,
   }
};

export default connect(
   mapCardMainContainerStateToProps,
   () => {}
)(CardMainContainer);

export function GreySpaceCardSummaryView(props) {
   return (
      <div className='grey-space-card-summary-item'>
         {props.synopsis}
      </div>
   );
}
